export default __webpack_public_path__ + "static/media/avatarSmall.7313de05.svg";